//Action Plan Categories (Folders)
export const GET_ACTION_PLAN_CATEGORIES = "GET_ACTION_PLAN_CATEGORIES"
export const GET_ACTION_PLAN_CATEGORIES_SUCCESS = "GET_ACTION_PLAN_CATEGORIES_SUCCESS"
export const GET_ACTION_PLAN_CATEGORIES_FAIL = "GET_ACTION_PLAN_CATEGORIES_FAIL"

export const ADD_ACTION_PLAN_CATEGORY = "ADD_ACTION_PLAN_CATEGORY"
export const ADD_ACTION_PLAN_CATEGORY_SUCCESS = "ADD_ACTION_PLAN_CATEGORY_SUCCESS"
export const ADD_ACTION_PLAN_CATEGORY_ERROR = "ADD_ACTION_PLAN_CATEGORY_ERROR"

export const UPDATE_ACTION_PLAN_CATEGORY = "UPDATE_ACTION_PLAN_CATEGORY"
export const UPDATE_ACTION_PLAN_CATEGORY_SUCCESS = "UPDATE_ACTION_PLAN_CATEGORY_SUCCESS"
export const UPDATE_ACTION_PLAN_CATEGORY_FAIL = "UPDATE_ACTION_PLAN_CATEGORY_FAIL"

export const DELETE_ACTION_PLAN_CATEGORY = "DELETE_ACTION_PLAN_CATEGORY"
export const DELETE_ACTION_PLAN_CATEGORY_SUCCESS = "DELETE_ACTION_PLAN_CATEGORY_SUCCESS"
export const DELETE_ACTION_PLAN_CATEGORY_ERROR = "DELETE_ACTION_PLAN_CATEGORY_ERROR"

//Action Plans
export const GET_ACTION_PLANS = "GET_ACTION_PLANS"
export const GET_ACTION_PLANS_SUCCESS = "GET_ACTION_PLANS_SUCCESS"
export const GET_ACTION_PLANS_FAIL = "GET_ACTION_PLANS_FAIL"

//All plans for the agent (unfiltered by folder) — used to compute per-folder plan counts
export const GET_ALL_ACTION_PLANS = "GET_ALL_ACTION_PLANS"
export const GET_ALL_ACTION_PLANS_SUCCESS = "GET_ALL_ACTION_PLANS_SUCCESS"
export const GET_ALL_ACTION_PLANS_FAIL = "GET_ALL_ACTION_PLANS_FAIL"

export const GET_ACTION_PLAN_DETAIL = "GET_ACTION_PLAN_DETAIL"
export const GET_ACTION_PLAN_DETAIL_SUCCESS = "GET_ACTION_PLAN_DETAIL_SUCCESS"
export const GET_ACTION_PLAN_DETAIL_FAIL = "GET_ACTION_PLAN_DETAIL_FAIL"
export const CLEAR_ACTION_PLAN_DETAIL = "CLEAR_ACTION_PLAN_DETAIL"

export const ADD_UPDATE_ACTION_PLAN = "ADD_UPDATE_ACTION_PLAN"
export const ADD_UPDATE_ACTION_PLAN_SUCCESS = "ADD_UPDATE_ACTION_PLAN_SUCCESS"
export const ADD_UPDATE_ACTION_PLAN_ERROR = "ADD_UPDATE_ACTION_PLAN_ERROR"

export const DELETE_ACTION_PLAN = "DELETE_ACTION_PLAN"
export const DELETE_ACTION_PLAN_SUCCESS = "DELETE_ACTION_PLAN_SUCCESS"
export const DELETE_ACTION_PLAN_ERROR = "DELETE_ACTION_PLAN_ERROR"
